import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ym from 'react-yandex-metrika';
import cx from 'classnames';

import { changeCurrentOrder } from '../../../Actions/changeCurrentOrder';
import { setLastGood } from '../../../Actions/app';
import checkGoodInOrder from '../../../utilities/checkGoodInOrder';
import FormatePrice from '../../../utilities/FormatPrice';
import tplNewOrder from '../../../utilities/tplNewOrder';
import { URL_API } from '../../../config';
import s from './PaySection.module.scss';
import Button from '../../../components/Button/Button';
import PriceDialogForm from '../../PriceDialogForm/PriceDialogForm';

const PaySection = props => {
  const {
    id,
    currentOrder,
    goods,
    t,
    changeOrder,
    attachedGoods,
    setLastGood_
  } = props;

  const btnStyle = {
    color: '#fff',
    hoverColor: '#fff',
    backgroundColor: '#669900',
    borderColor: '#669900',
    hoverBackgroundColor: '#568200',
    hoverBorderColor: '#568200'
  };

  const btnStyleInOrder = {
    color: '#fff',
    hoverColor: '#fff',
    backgroundColor: '#f17811',
    borderColor: '#f17811',
    hoverBackgroundColor: '#d5690e',
    hoverBorderColor: '#d5690e'
  };

  const btnOptions = {
    size: 'small'
  };

  if (t.language === 'ru') {
    const price = goods[id].cost;
    const oldPrice = goods[id].old_cost;

    let orderGoods =
      currentOrder && currentOrder.order && currentOrder.order.goods;

    if (orderGoods === undefined) orderGoods = [];

    const inOrder = checkGoodInOrder(orderGoods, id);

    const addAttachedGoods = () => {
      const result = [];
      if (attachedGoods[id]) {
        // eslint-disable-next-line no-restricted-syntax
        for (const key in attachedGoods[id]) {
          if ({}.hasOwnProperty.call(attachedGoods[id], key)) {
            result.push({ shopGood: key, count: attachedGoods[id][key] });
          }
        }
      }
      return result;
    };

    const addGood = () => {
      setLastGood_(id);
      if (!currentOrder.order) {
        changeOrder(
          {
            ...tplNewOrder(),
            goods: [
              ...orderGoods,
              { shopGood: id, count: 1 },
              ...addAttachedGoods()
            ]
          },
          0,
          1
        );
      } else {
        changeOrder(
          {
            goods: [
              ...orderGoods,
              { shopGood: id, count: 1 },
              ...addAttachedGoods()
            ]
          },
          0,
          1
        );
      }
    };

    const handleProduct = () => {
      // #73111
      // if (id === '1') {
      //   window.open('https://ecgdongle.com', '_blank');
      //   return;
      // }
      // eslint-disable-next-line no-unused-expressions
      if (inOrder) {
        window.location = `${URL_API}/store`;
      } else {
        addGood();
        if (window.location.host === 'cardio-cloud.ru') {
          ym('reachGoal', 'AddToCart');
        }
      }
    };

    const buttonText = inOrder ? t['Оформить заказ'] : t['В корзину'];
    // #73111
    // if (id === '1') {
    //   buttonText = t['Заказать'];
    // }

    return (
      <div className={s.main}>
        <span className={s.price}>{FormatePrice(price)} ₽</span>
        {!!+oldPrice && oldPrice !== price ? (
          <span className={cx(s.price, s.oldPrice)}>
            {FormatePrice(oldPrice)} ₽
          </span>
        ) : null}
        <div className={s.btn} onClick={handleProduct}>
          <Button
            btnStyle={inOrder ? btnStyleInOrder : btnStyle}
            btnOptions={btnOptions}
            text={buttonText}
          />
        </div>
      </div>
    );
  }

  const buttonPriceDialogForm = state => (
    <Button
      btnStyle={btnStyle}
      btnOptions={btnOptions}
      text={state.title}
      disabled={state.disabled}
    />
  );

  return (
    <div className={s.main}>
      <span className={s.priceEn}>{t['Цена по запросу']}</span>
      <PriceDialogForm
        buttonPriceDialogForm={buttonPriceDialogForm}
        goodId={id}
        goodName={goods[id].name}
      />
    </div>
  );
};

PaySection.defaultProps = {
  changeOrder: PropTypes.func
};

const mapStateToProps = state => ({
  currentOrder: state.currentOrder,
  goods: state.goods,
  t: state.translation,
  attachedGoods: state.app.attachedGoods
});

const mapDispatchToProps = {
  changeOrder: changeCurrentOrder,
  setLastGood_: setLastGood
};

export default connect(mapStateToProps, mapDispatchToProps)(PaySection);
